import React from "react";
import { IconButton } from "@mui/material";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { IUserDetails } from "repoV2/features/Common/modules/FormData/interfaces/UserDetailsFormGroup.interfaces";
import styles from "./SingleUserCard.module.scss";

const SingleUserCard = (props: {
    singleUserDetails: IUserDetails;
    currentUserId: string;
    onDelete: (userId: string) => void;
    onEdit: (userId: string) => void;
}) => {
    const { singleUserDetails, currentUserId, onDelete, onEdit } = props;
    return (
        <div className={styles.singleCardContainer}>
            <div className={styles.nameIconContainer}>
                <AccountCircleRoundedIcon className={styles.userIconStyle} />
                <div className={styles.userNameStyle}>
                    {singleUserDetails.name}
                </div>
            </div>
            <div className={styles.iconsContainer}>
                <IconButton
                    className={styles.iconButtonStyle}
                    onClick={() => onEdit(currentUserId)}
                >
                    <EditOutlinedIcon className={styles.editIconStyle} />
                </IconButton>
                <IconButton
                    className={styles.iconButtonStyle}
                    onClick={() => onDelete(currentUserId)}
                >
                    <DeleteOutlineOutlinedIcon
                        className={styles.deleteIconStyle}
                    />
                </IconButton>
            </div>
        </div>
    );
};

export default SingleUserCard;
